module.exports = __webpack_public_path__ + "static/media/calendar.441c74e6.svg";